import Delete from '@mui/icons-material/Delete';
import CircularProgress from '@mui/material/CircularProgress';
import IconButton from '@mui/material/IconButton';
import Paper from '@mui/material/Paper';
import Tooltip from '@mui/material/Tooltip';
import moment from "moment";
import { Component } from 'react';
import { connect } from 'react-redux';
import { confirmAction, showError, showMessage } from '../../actions/uiActions';
import EinApi from '../../api/eins';
import PaginatedTable from '../../components/PaginatedTable';
import Formatter from '../../utils/Formatter';
import { withRouter } from '../../utils/withRouter';

class EINS extends Component
{

    state = {
        loading: true,
        isEmpty: false,
        deleting: false,
        ein: null,
        eins: [],
        count: 0,
        page: 0,
        einId: null,
        currentTab: 0
    }

    componentDidMount()
    {
        this.getEins(this.state.page);
    }

    getEins = async (page) =>
    {
        try
        {
            const result = await EinApi.getEins(this.props.match.params.domainId, page)
            if (result)
            {
                this.setState({ loading: false, eins: result.eins, page: result.page, pages: result.pages, count: result.count })
            }
        } catch (error)
        {
            this.setState({ loading: false }, this.props.showError)
        }
    }

    delete = (ein) =>
    {
        this.props.confirmAction("You are going to delete this ein permanentely, Do you want to proceed?",
            () => this.setState({ deleting: true, ein: { _id: ein._id } }, () =>
            {
                if (!ein.default)
                {
                    EinApi.deleteEin(ein._id).then(success =>
                    {
                        this.props.showMessage("The Ein has been deleted. This may take few minutes to reflect depends on data size");
                        this.setState({ deleting: false, ein: null, busy: false })
                        this.getEins(this.props.match.params.domainId);
                    }, error => this.setState({ deleting: false, ein: null }, this.props.showError))
                        .catch(error => this.setState({ deleting: false, ein: null }, this.props.showError))
                } else
                {
                    this.props.showMessage("Sorry you can't delete the default ein");
                    this.setState({ deleting: false, ein: null, busy: false })
                }
            }))
    }

    render()
    {
        return (
            <div>
                <div className="row">
                    <div className="col-12">
                        <Paper>
                            <PaginatedTable goToPage={this.getEins} count={parseInt(this.state.count.toString())} page={parseInt(this.state.page.toString())} loading={this.state.loading} rows={this.state.eins.map(ein =>
                            {
                                return {
                                    properties: {
                                        key: ein._id
                                    },
                                    columns:
                                        [
                                            {
                                                properties: {
                                                    key: `${ein._id}-1`
                                                },
                                                value: `${ein.name}`
                                            },
                                            {
                                                properties: {
                                                    key: `${ein._id}-2`
                                                },
                                                value: (ein.description && Formatter.printMaxCharacters(ein.description, 30)) || 'Unknown'
                                            },
                                            {
                                                properties: {
                                                    key: `${ein._id}-4`
                                                },
                                                value: moment.unix(ein.date).format("MM/DD/YYYY")
                                            },
                                            {
                                                properties: {
                                                    key: `${ein._id}-5`
                                                },
                                                value: <div className="text-centers">
                                                    {this.state.ein && this.state.ein._id == ein._id ? <CircularProgress size={24} /> :
                                                        <>
                                                            <Tooltip title="Delete Ein">
                                                                <IconButton disabled={this.state.deleting && this.state.ein && this.state.ein._id == ein._id} onClick={() => this.delete(ein)}>
                                                                    <Delete />
                                                                </IconButton>
                                                            </Tooltip>
                                                        </>
                                                    }

                                                </div>
                                            }
                                        ]
                                };
                            })}
                                emptyMessage="No eins have been added"
                                columns={[
                                    {
                                        name: "Name",
                                        properties:
                                        {
                                            key: 1,
                                            className: "width30pct"
                                        }
                                    },
                                    {
                                        name: "Ein Description",
                                        properties:
                                        {
                                            key: 2,
                                            className: "width40pct"
                                        }
                                    },
                                    {
                                        name: "Modified Date",
                                        properties:
                                        {
                                            key: 4,
                                            className: "width40pct"
                                        }
                                    },
                                    {
                                        name: "Options",
                                        properties:
                                        {
                                            key: 5,
                                            className: "width40pct"
                                        }
                                    }
                                ]} />
                        </Paper>
                    </div>
                </div>

            </div>
        )
    }
}
export default withRouter(connect(null, { showError, showMessage, confirmAction })(EINS));